import axiosClientHyperWolf from "axiosClient/indexHyperWolf";
export async function updateCreditCardSettingsAPI(data) {
    return await axiosClientHyperWolf.post(`/api/v1/update/ccfees/status?storeId=`, data);
}

export async function fetchCreditCardSettingsAPI(storeId) {
    return await axiosClientHyperWolf.get(`/api/v1/ccfees/status?storeId=`);
}

export async function updateOrderMinimumSettingsAPI(data) {
    return await axiosClientHyperWolf.post(`/api/v1/update/min/amount/settings`, data);
}

export async function fetchOrderMinimumSettingsAPI(storeId) {
    return await axiosClientHyperWolf.get(`/api/v1/fetch/min/amount/settings`);
}
